import { Routes, Route, Navigate } from 'react-router-dom';
import { PUBLIC_ROUTES } from '@bemap/utils';
import Login from '../pages/login/login-page';
import ResetPassword from '../pages/reset-password/reset-password-page';
import CallbackPage from '../pages/callback/callback-page';
import { FC } from 'react';

const PublicRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={PUBLIC_ROUTES.LOGIN} replace />} />
      <Route path={PUBLIC_ROUTES.LOGIN} element={<Login />} />
      <Route path={PUBLIC_ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
      <Route path="/callback" element={<CallbackPage />} />
      <Route path="*" element={<Navigate to={PUBLIC_ROUTES.LOGIN} replace />} />
    </Routes>
  );
};

export default PublicRoutes; 